export default {
  MuiSwitch: {
    styleOverrides: {
      root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: 8
      },
      switchBase: {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        transform: 'translateX(0)',
        '&.Mui-checked': {
          transform: 'translateX(16px)',
          color: '#fff',
          '& + .MuiSwitch-track': {
            backgroundColor: '#Ceb6d9',
            opacity: 1,
            border: 0
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5
          }
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
          color: '#33cf4d',
          border: '6px solid #fff'
        }
      },
      thumb: {
        boxSizing: 'border-box',
        width: 16,
        height: 16,
        boxShadow: 'none'
      },
      track: {
        borderRadius: 20 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: 'background-color 500ms',
        border: 'none'
      },
      checked: {}
    }
  }
};
